import React from "react"
import { Col, Form, Radio, Row } from "antd"
import { useLesson } from "../../hooks/lesson-context"

export function TrueAndFalse({
  question,
  questionIndex,
  isFacilitate = false,
  disabled = false,
  required = false,
  inReview = false,
  trackQuestionSubmission,
}) {
  const { state: ctxState, dispatch: ctxDispatch } = useLesson()
  const isWrong = (answer) => {
    if (!inReview) return ""
    const radio = document.getElementById(answer.uid)
    if (radio?.checked && answer.correct === 0) {
      return "option__choice--wrong"
    }
    return ""
  }

  return (
    <Form.Item
      name={question.uid}
      rules={[
        {
          required,
          message: "Please select an answer",
        },
      ]}
    >
      <Radio.Group disabled={ctxState?.actionRunning} style={{ width: "100%" }}>
        <Row gutter={["16", "16"]}>
          {question.answers.map((answer) => {
            return (
              <Col key={answer.uid} style={{ marginBottom: "1rem" }} xs={24} sm={24} lg={12}>
                <Radio
                  id={answer.uid}
                  onChange={() => {
                    trackQuestionSubmission({
                      data: answer.correct,
                      typeUid: question.uid,
                      type: question.type,
                    })
                  }}
                  className={`option__choice ${
                    isFacilitate !== "true" && inReview && answer.correct === 1 ? "option__choice--correct" : ""
                  } ${isWrong(answer)}`}
                  value={answer.correct}
                >
                  {/* {answer?.title || answer?.translations?.["1"]?.title} */}
                  {answer?.content?.title || "No title found"}
                </Radio>
              </Col>
            )
          })}
        </Row>
      </Radio.Group>
    </Form.Item>
  )
}
